import { CommonModule } from '@angular/common';
import { Injector, NgModule } from '@angular/core';
import { SagaPipeModule } from '@app/pipes/module';
import { IonicModule } from '@ionic/angular';
import { Addin, AddinModule } from '@techwan/ionic-core';
import { AttachmentItemComponent } from './components/attachment-item/attachment-item.component';
import { AttachmentModalComponent } from './components/attachment-modal/attachment-modal.component';
import { SINGLECALLCARD_ATTACHMENTS } from './schema/constants';
import { AddAttachmentToolsControllerService } from './services/add-attachment-tools-controller/add-attachment-tools-controller.service';
import { AttachmentsCardButtonControllerService } from './services/attachments-card-button-controller/attachments-card-button-controller.service';
import { AttachmentToolsSetupService } from './services/executables/attachment-tools-setup/attachment-tools-setup.service';

const views = [];

const executables = [AttachmentToolsSetupService];

const providers = [AddAttachmentToolsControllerService, AttachmentsCardButtonControllerService, ...executables];

const components = [AttachmentModalComponent, AttachmentItemComponent, ...views];

const directives = [];

@Addin({
  name: SINGLECALLCARD_ATTACHMENTS,
  require: ['Media']
})
@NgModule({
  declarations: [...components, ...directives],
  providers,
  imports: [CommonModule, IonicModule, SagaPipeModule]
})
export class SingleCallcardAttachmentsModule extends AddinModule {
  public constructor(injector: Injector) {
    super(injector, views, executables);
  }
}
